const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.916667,0,0,0.916667,20,20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-b",
    transform: "matrix(1,0,0,1,-12,-12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.39488,0,0,1.42857,-4.73861,-5.14286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,5L18.5,5C18.9,5.14 19.169,5.52 19.169,5.944C19.169,6.142 19.11,6.335 19,6.5L14,12L14,19L10,16L10,12L5,6.5C4.89,6.335 4.831,6.142 4.831,5.944C4.831,5.52 5.1,5.14 5.5,5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "1.42px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterB);
export default __webpack_public_path__ + "static/media/filter-b.d06395356ea78ea003fb21136c4171cf.svg";
export { ForwardRef as ReactComponent };